<div class="sidebar-account-section">
  <app-sidebar-button
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    data-test="account-menu-button"
    name="account"
    [selected]="isAccountMenuOpen || selectedSideMenuName === 'account'"
    (click)="toggleAccountMenu()"
  />
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isAccountMenuOpen"
    (overlayOutsideClick)="toggleAccountMenu()"
  >
    <div class="sidebar-account-menu-wrapper">
      @if (companies.length > 1) {
        <app-form-field-select
          [hideErrorPanel]="true"
          [control]="companiesControl"
          [options]="companiesOptions"
        />
      } @else if (companies.length === 1) {
        <div class="sidebar-company-identity">
          <div class="sidebar-company-name">{{ companies[0].display_name }}</div>
          @if (accountEmail) {
            <div class="sidebar-company-email">{{ accountEmail }}</div>
          }
        </div>
        <div class="sidebar-button-border"></div>
      }
      @if (loading) {
        <app-spinner position="overlay" />
      }
      <a
        mat-stroked-button
        data-test="settings-link"
        data-analytics="account-settings-menu-item"
        class="sidebar-settings-button"
        color="primary"
        routerLink="/user/profile"
        (click)="toggleAccountMenu()"
      >
        Settings
      </a>
      <div>
        <button
          mat-button
          data-test="logout-button"
          data-analytics="account-log-out-menu-item"
          class="sidebar-logout-button"
          color="primary"
          (click)="logout()"
        >
          Log out
        </button>
      </div>
    </div>
  </ng-template>
</div>
